
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.mv-swiper', {
    effect: 'fade', // フェード効果を有効化
    loop: true, // 無限ループ
    speed: 2000,
    autoplay: {
      delay: 3000, // 3秒ごとに切り替え
      disableOnInteraction: false, // ユーザー操作後も自動再生を継続
    },
    fadeEffect: {
      crossFade: true, // クロスフェードを有効化
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.products-swiper .swiper-container', {
    loop: true,
    speed: 4000, // アニメーション速度（ミリ秒）
    autoplay: {
      delay: 0, // 遅延なし
      disableOnInteraction: false,
    },
    slidesPerView: 3.5, // スライドを自動調整
    spaceBetween: 8, // スライド間のスペース
    freeMode: true, // 等速スクロール
    breakpoints: {
      768: {
        slidesPerView: 5.5, // スライド数
        spaceBetween: 20, // スライド間のスペース
      },
    },
  });
});